import { styled } from "@mui/material";

export default function NameProductCard({ children }) {
	const StyledComponent = styled("h6")(({ theme }) => ({
		fontFamily: "Fjalla One",
		fontSize: "1.25rem",
		color: "#fff",
		margin: 0,
		zIndex: 10,
		[theme.breakpoints.down("sm")]: {
			fontSize: "1rem",
		},
	}));

	return <StyledComponent>{children}</StyledComponent>;
}
